// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc, IconNews } from '@tabler/icons';

import StoreIcon from '@mui/icons-material/Store';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import ListAltIcon from '@mui/icons-material/ListAlt';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc    
};

const icoNew = {
    StoreIcon,
    StorefrontIcon,
    LocalGroceryStoreIcon,
    PointOfSaleIcon,
    AssignmentReturnedIcon,
    ListAltIcon
}

// ==============================|| VENTA MENU ITEMS ||============================== //

const venta = {
    id: 'venta',
    title: '',
    type: 'group',
    children: [
        {
            id: 'ventasMainMenu',
            title: 'Ventas',
            type: 'collapse',
            icon: icoNew.StorefrontIcon,
            children: [
                {
                    id: 'ventas',
                    title: 'Ventas',
                    type: 'collapse',
                    icon: icoNew.LocalGroceryStoreIcon,
                    children: [
                        {
                            id: 'nueva_venta',
                            title: 'Nueva Venta',
                            type: 'item',
                            url: '/user/new-venta-view/0'
                        },
                        {
                            id: 'lista_ventas',
                            title: 'Lista Ventas',
                            type: 'item',
                            url: '/user/list-ventas-view'
                        },                        
                    ]
                },
                {
                    id: 'cajas_venta',
                    title: 'Cajas de Venta',
                    type: 'collapse',
                    icon: icoNew.PointOfSaleIcon,
                    children: [
                        {
                            id: 'nueva_caja_ventas',
                            title: 'Nueva Caja Ventas',
                            type: 'item',
                            url: '/user/new-caja-venta-view/0'
                        },
                        {
                            id: 'lista_cajas_ventas',
                            title: 'Lista Cajas Ventas',
                            type: 'item',
                            url: '/user/list-cajas-ventas-view'
                        },                
                    ]
                },
                {
                    id: 'devoluciones_venta',
                    title: 'Devoluciones Ventas',
                    icon: icoNew.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/busqueda-factura-lote'
                },
                {
                    id: 'devoluciones_factura_migrada_cxc',
                    title: 'Devoluciones CxC sistema anterior',
                    icon: icoNew.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/busqueda-factura-migrada-cxc'
                },
                {
                    id: 'devoluciones_sistema_anterior_sin_cxc',
                    title: 'Devolución sistema anterior sin CxC',
                    icon: icoNew.AssignmentReturnedIcon,
                    type: 'item',
                    url: '/user/devoluciones-sistema-anterior-sin-cxc'
                },
                {
                    id: 'list_devoluciones_venta',
                    title: 'Lista Devoluciones Ventas',
                    icon: icoNew.ListAltIcon,
                    type: 'item',
                    url: '/user/list-devoluciones-ventas'
                },
                {
                    id: 'list_nota_credito',
                    title: 'Lista Nota Crédito',
                    icon: icoNew.ListAltIcon,
                    type: 'item',
                    url: '/user/list-nota-credito'
                },
            ]
        }
    ]
};

export default venta;
